module.exports = __webpack_public_path__ + "static/media/ic-chevron-down-grey.505c269f.svg";